import React from 'react';
import { observer } from 'mobx-react-lite';
import { Helmet } from 'react-helmet';
import AdminLayout from './AdminLayout';
const Members = (props) => {
  return (
    <React.Fragment>
      <Helmet>
        <title>Simulcast - Portal</title>
      </Helmet>
      <AdminLayout
        laneName={props.location.state?.laneName}
        auctionName={props.location.state?.auctionName}
        AuctionID={props.match.params.auctionID}
        memberType={props.memberType}
        breadcrumbLocation={props.breadcrumbLocation}
      />
    </React.Fragment>
  );
};

export default observer(Members);
